import React, { useState } from "react";
import axios from "axios";

function ContactForm() {
  const [ime, setIme] = useState("");
  const [email, setEmail] = useState("");
  const [sporocilo, setSporocilo] = useState("");
  const [status, setStatus] = useState("");

  const handleSendMessage = async (e) => {
    e.preventDefault();
    setStatus("Pošiljam...");

    try {
      const data = new URLSearchParams();
      data.append("ime", ime);
      data.append("email", email);
      data.append("sporocilo", sporocilo);

      await axios.post("https://fnm-backend.aibc-robotics.com/send-support-email", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      setStatus("Sporočilo uspešno poslano!");
      setIme("");
      setEmail("");
      setSporocilo("");
    } catch (err) {
      console.error(err);
      setStatus("Napaka pri pošiljanju. Poskusi znova.");
    }
  };

  return (
    <div className="mt-16 w-full max-w-2xl bg-white rounded-xl shadow-md p-6 text-center">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">📩 Potrebuješ pomoč?</h3>
      <p className="text-gray-600 mb-4">
        Če imaš težave z nalaganjem ali prijavo, nam piši in z veseljem ti bomo pomagali.
      </p>
      <form onSubmit={handleSendMessage} className="space-y-4">
        <input
          type="text"
          name="ime"
          placeholder="Vaše ime"
          required
          value={ime}
          onChange={(e) => setIme(e.target.value)}
          className="w-full border border-gray-300 rounded-md p-2"
        />
        <input
          type="email"
          name="email"
          placeholder="Vaš e-poštni naslov"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border border-gray-300 rounded-md p-2"
        />
        <textarea
          name="sporocilo"
          placeholder="Vaše sporočilo"
          rows="4"
          required
          value={sporocilo}
          onChange={(e) => setSporocilo(e.target.value)}
          className="w-full border border-gray-300 rounded-md p-2"
        ></textarea>
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
        >
          Pošlji sporočilo
        </button>
        {status && <p className="text-sm text-gray-500 mt-2">{status}</p>}
      </form>
    </div>
  );
}

export default ContactForm;
